// extracted by mini-css-extract-plugin
module.exports = {"subsCardList":"subsCardList___1d5wX","titleBox":"titleBox___3iLh4"};